import selectColorTypeImages from "@/components/common/selectColorTypeImages";

export const AddButtonImagesData = [
  {
    value: "Shop now",
    icon: "",
  },
  {
    value: "Learn more",
    icon: "",
  },
  {
    value: "Visit us online",
    icon: "",
  },
  {
    value: "Custom",
    icon: "/common/edit-icon.svg",
  },
];

export const ImageInitialData = {
  payload: {
    design_colors_primary: selectColorTypeImages[0].color,
    design_colors_button: selectColorTypeImages[0].buttonColor,
    headline: "",
    description: "",
    button: "",
    button_url: "",
    website: "",
    image_grid_view: "0",
  },
  initialFiles: [
    // Store default images separately
    {
      originalName: "fashion1.jpg",
      id: 0,
      metadata: { caption: "Your Caption..." },
      path: "empty",
      url: `/builder/qr-types/1.jpg`,
    },
    {
      originalName: "fashion2.jpg",
      id: 1,
      metadata: { caption: "Your Caption..." },
      path: "empty",
      url: `/builder/qr-types/2.jpg`,
    },
    {
      originalName: "fashion3.jpg",
      id: 2,
      metadata: { caption: "Your Caption..." },
      path: "empty",
      url: `/builder/qr-types/3.jpg`,
    },
  ],
  files: {
    images: null,
  },
};
